import { fromPairs, map, pipe } from "ramda";

export const makeDisplayName = (id, displayName) => {
  return id ? `${displayName} (${id})` : "";
};

export const getAutocompleteSource = pipe(
  map(({ id, displayName }) => [id, makeDisplayName(id, displayName)]),
  fromPairs,
);

export const getDropdownSource = map(({ id, displayName }) => ({
  value: id,
  label: makeDisplayName(id, displayName),
}));
